import React, { useState, useEffect } from "react";
import { MapPin, Key, Phone, CircleCheck } from "lucide-react";

const buildNavigateUrl = (loc) => {
  if (!loc) return null;

  const lat = loc.lat ?? loc.latitude ?? loc.latLng?.lat;
  const lng = loc.lng ?? loc.longitude ?? loc.latLng?.lng;

  if (lat == null || lng == null) return null;

  return `https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}`;
};

const DropoffPage = ({ deliveryGroup, onDelivered }) => {
  const customer = deliveryGroup?.customer_details || {};
  const deliveryLoc = deliveryGroup?.delivery_location;
  const navigateUrl = buildNavigateUrl(deliveryLoc);

  const [stage, setStage] = useState("navigate"); // navigate | reached | otp
  const [otp, setOtp] = useState("");
  const [loading, setLoading] = useState(false);
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [otpGenTime, setOtpGenTime] = useState(null);
  const [now, setNow] = useState(Date.now());

  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, []);

  useEffect(() => {
  if (!deliveryGroup) return;

  // Check if OTP already exists in backend
  const otpExists = deliveryGroup.order_delivered_otp;
  console.log(deliveryGroup)
  if (!otpExists) return;

  
  setStage("otp");

  // Try to get OTP generation time from backend timestamps
  const backendTime =
    deliveryGroup.updated_at ||
    deliveryGroup.updatedAt ||
    deliveryGroup.otp_generated_at;

  let generatedTime = Date.now();

  if (backendTime) {
    const parsedTime = new Date(backendTime);
    if (!isNaN(parsedTime.getTime())) {
      generatedTime = parsedTime.getTime();
    }
  }

  setOtpGenTime(generatedTime);
}, [deliveryGroup]);


  // Auto-generate OTP when reached
 /*  const handleReached = async () => {
    setLoading(true);
    setStage("reached");

    try {
      await new Promise((resolve) => setTimeout(resolve, 800));

      const URL = process.env.REACT_APP_FORE_BRICKBUCKET;

      if (!URL || URL === "" || URL === "undefined") {
        console.log("Mock: Delivery OTP auto-generated");
      } else {
        try {
          const token = sessionStorage.getItem("token");

          await fetch(
            `${URL}customer/salesorder/generate-order-delivered-otp`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                "x-token": token || "",
              },
              body: JSON.stringify({ DG_id: deliveryGroup.id }),
            }
          );
        } catch (e) {
          console.log("API failed, using mock");
        }
      }

      setStage("otp");
      setOtpGenTime(Date.now());
    } catch (err) {
      console.error("Error:", err);
      setStage("otp");
      setOtpGenTime(Date.now());
    } finally {
      setLoading(false);
    }
  }; */

  const handleReached = async () => {
  try {
    setLoading(true);

    const URL = process.env.REACT_APP_FORE_BRICKBUCKET;
    const token = sessionStorage.getItem("token");

    const res = await fetch(
      `${URL}customer/salesorder/generate-order-delivered-otp`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-token": token || "",
        },
        body: JSON.stringify({
          DG_id: deliveryGroup.id,
        }),
      }
    );

    const data = await res.json();
    console.log(data)
    setLoading(false);

    if (!res.ok || !data.success) {
      alert(data.message || "Failed to generate OTP");
      return;
    }

    // ✅ OTP generated successfully
    setStage("otp");
    setOtpGenTime(Date.now());

  } catch (err) {
    console.error("Error generating OTP:", err);
    setLoading(false);
    alert("Error generating OTP. Please try again.");
  }
};

 /*  const handleResendOTP = async () => {
    setLoading(true);
    await new Promise((resolve) => setTimeout(resolve, 800));
    setOtpGenTime(Date.now());
    setLoading(false);
  }; */

const handleResendOTP = async () => {
  try {
    setLoading(true);

    const URL = process.env.REACT_APP_FORE_BRICKBUCKET;
    const token = sessionStorage.getItem("token");

    const res = await fetch(
      `${URL}customer/salesorder/generate-order-delivered-otp`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-token": token || "",
        },
        body: JSON.stringify({
          DG_id: deliveryGroup.id,
        }),
      }
    );

    const data = await res.json();
    setLoading(false);

    if (!res.ok || !data.success) {
      alert(data.message || "Failed to resend OTP");
      return;
    }

    // ✅ OTP regenerated successfully
    setOtpGenTime(Date.now());

  } catch (err) {
    console.error("Resend OTP failed:", err);
    setLoading(false);
    alert("Error while resending OTP. Please try again.");
  }
};


  const verifyOTP = async () => {
  try {
    setLoading(true);

    const URL = process.env.REACT_APP_FORE_BRICKBUCKET;
    const token = sessionStorage.getItem("token");

    const res = await fetch(
      `${URL}customer/salesorder/verify-order-delivered-otp`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-token": token || "",
        },
        body: JSON.stringify({
          DG_id: deliveryGroup.id,
          otp: Number(otp),
        }),
      }
    );

    const data = await res.json();
    setLoading(false);

    if (!res.ok || !data.success) {
      alert(data.message || "Invalid OTP");
      return;
    }

    // ✅ OTP verified successfully — show success popup
    setShowSuccessPopup(true);

    // Move to completed state after animation
    setTimeout(() => {
      onDelivered && onDelivered();
    }, 2000);

  } catch (err) {
    console.error("OTP verification failed:", err);
    setLoading(false);
    alert("OTP Verification Failed. Please try again.");
  }
};


  return (
    <div className="p-5">
      <h3 className="font-bold text-gray-900 mb-5">Delivery</h3>

      <div className="bg-white border-2 border-gray-200 p-5 rounded-2xl shadow-sm mb-5">
        <h4 className="font-bold text-gray-900 mb-3">Drop Off Location</h4>

        <div className="text-sm text-gray-700 space-y-2 mb-4">
          <div className="flex items-center gap-2">
            <span className="font-semibold">Name:</span>
            <span>{customer.customer_name || "N/A"}</span>
          </div>

          <div className="flex items-center gap-2">
            <Phone className="w-4 h-4" />
            <span className="font-semibold">Mobile:</span>
            <a
              href={`tel:${customer.mobile_number}`}
              className="text-blue-600 underline"
            >
              {customer.mobile_number || "---"}
            </a>
          </div>
        </div>

        {navigateUrl && stage !== "otp" && (
          <a
            href={navigateUrl}
            target="_blank"
            rel="noreferrer"
            className="flex items-center justify-center gap-3 px-4 py-4 bg-red-600 text-white rounded-xl hover:bg-red-700 transition-colors"
          >
            <MapPin className="w-6 h-6" />
            <span className="font-bold">Navigate</span>
          </a>
        )}
      </div>

      {stage === "navigate" && (
        <button
          onClick={handleReached}
          disabled={loading}
          className="w-full py-5 bg-blue-600 text-white rounded-xl font-bold hover:bg-blue-700 transition-colors shadow-lg disabled:bg-gray-400"
        >
          {loading ? "Loading..." : " Reached"}
        </button>
      )}

      {stage === "otp" && (
        <div className="bg-white border-2 border-gray-200 p-5 rounded-2xl shadow-sm">
          <h4 className="font-bold text-gray-900 mb-5 flex items-center gap-3">
            <Key className="w-6 h-6" />
            <span>Enter Delivery OTP</span>
          </h4>

          <input
            type="text"
            maxLength={4}
            value={otp}
            onChange={(e) => {
              const v = e.target.value;
              if (/^[0-9]{0,4}$/.test(v)) setOtp(v);
            }}
            className="border-2 border-gray-300 rounded-xl w-full p-4 text-center text-2xl font-bold mb-5 tracking-widest focus:outline-none focus:border-blue-500"
            placeholder="----"
            inputMode="numeric"
            autoFocus
          />

          {otpGenTime && (
            <div className="flex justify-between items-center mb-5 text-sm text-gray-600">
              {/* <div>
                {Math.floor((now - otpGenTime) / 1000) >= 0
                  ? `${Math.floor((now - otpGenTime) / 1000)}s ago`
                  : "Just now"}
              </div> */}

             {/*  <div>
                {Math.floor((now - otpGenTime) / 1000) >= 60 ? (
                  <button
                    onClick={handleResendOTP}
                    className="px-4 py-2 text-sm bg-yellow-500 text-white rounded-lg font-bold hover:bg-yellow-600"
                    disabled={loading}
                  >
                    Resend
                  </button>
                ) : (
                  <div className="text-xs text-gray-500 font-semibold">
                   
                  </div>
                )}
              </div> */}
            </div>
          )}

          <button
            onClick={verifyOTP}
            disabled={otp.length !== 4 || loading}
            className={`w-full py-4 rounded-xl font-bold transition-colors ${
              otp.length === 4 && !loading
                ? "bg-green-600 text-white hover:bg-green-700"
                : "bg-gray-300 text-gray-500 cursor-not-allowed"
            }`}
          >
            {loading ? "Verifying..." : "Verify OTP"}
          </button>
        </div>
      )}

      {showSuccessPopup && (
        <div className="fixed inset-0 bg-black/40 flex justify-center items-center z-50">
          <div className="bg-white p-8 rounded-2xl shadow-2xl text-center w-full max-w-sm animate-fadeIn">
            <CircleCheck className="text-green-600 mx-auto mb-4 w-16 h-16" />
            <div className="font-bold text-green-700">
              Delivery Completed!
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default DropoffPage;
